module.exports = __webpack_public_path__ + "img/ic_folder.8169a7d6.svg";